<template>
	<div class="home">
		<img
			alt="downloadapp"
			src="@/assets/downloadapp.jpg"
			@click="moveToApp"
		/>
		<Copyright />
	</div>
</template>

<script>
import Copyright from "@/components/Copyright.vue";
import { LaunchApp, copy, isAndroid, inWeixin } from "web-launch-app";
import { checkUserStatus } from "@/utils/login.js";
import { microDownloadUrl } from "@/config.js";

const lanchApp = new LaunchApp();

export default {
	name: "DownloadApp",
	components: {
		Copyright
	},
	data() {
		return {};
	},
	mounted() {
		checkUserStatus(this.$route);
	},
	methods: {
		moveToApp() {
			// 复杂唤起
			lanchApp.open(
				{
					useYingyongbao: inWeixin && isAndroid,
					launchType: {
						ios: inWeixin ? "store" : "link",
						android: inWeixin ? "store" : "scheme"
					},
					autodemotion: false,
					scheme: "lexiang://path?k=v",
					url: microDownloadUrl,
					param: {
						k2: "v2"
					},
					timeout: 2000,
					pkgs: {
						android:
							"https://a.app.qq.com/o/simple.jsp?pkgname=com.yunzhihui.lexiang",
						ios:
							"https://a.app.qq.com/o/simple.jsp?pkgname=com.yunzhihui.lexiang",
						yyb:
							"https://a.app.qq.com/o/simple.jsp?pkgname=com.yunzhihui.lexiang"
					}
				},
				(s, d, url) => {
					console.log("callbackout", s, d, url);
					s != 1 && copy(url);
					return 2;
				}
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.home {
	position: relative;
	img {
		text-align: center;
		width: 48.9vh;
		height: 100vh;
	}
}

@media screen and (max-width: 450px) {
	.home {
		position: relative;
		img {
			width: 100vw;
			height: 204.53vw;
		}
	}
}
</style>